import { useState, useEffect } from "react";
import { Domains } from "@/core/types/types";
import {
  getTopLevelDomain,
  getDatePickerLocaleByTLD as getDateLocaleByTLD,
} from "@/core/utils";

export const useDateLocale = () => {
  const [locale, setLocale] = useState<Locale>();

  useEffect(() => {
    const tld: Domains | string = getTopLevelDomain() || Domains.NET;
    const locale: Locale = getDateLocaleByTLD(tld as Domains);

    setLocale(locale);
  }, []);

  return locale;
};
